import { STORE_KEY, INITIAL_STATE } from './slice';
import { redux } from 'Core/redux';

export const selectState = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectReceivingShipmentData = state => selectState(state).data || [];
export const selectReceivingShipmentLoading = state => Boolean(selectState(state).loading);
export const selectReceivingFilterVisible = state => Boolean(selectState(state).filterVisible);
export const selectReceivingShipmentFilters = state => selectState(state).filters || INITIAL_STATE.filters;
